<template>
  <div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Naam</th>
        <th>E-mailadres</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="contact in contacts">
        <td><a class="hoverable" @click="$router.push({ name: 'contacts.view', params: { id: contact.id} })">{{contact.name}}</a></td>
        <td>{{contact.email}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'account-contacts',
  props: ['contacts'],
}
</script>
